<template>
    <div class="row report-row">
        <div class="col-md-12">
            <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>

            <card v-else >
                <template slot="header">
                    <div class="d-flex justify-content-between">
                        User Activity
                        <el-button
                            v-if="user.admin || (user.adminRoles && user.adminRoles[user._id] && user.adminRoles[user._id].downloadReports) || (user.roles && user.roles[eventId] && user.roles[eventId].downloadReports)"
                            class="btn btn-primary"
                            :loading="downloading"
                            @click="downloadUserLog()">
                                Download
                                <fa icon="download"/>
                        </el-button>
                    </div>
                </template>
                <table class="table table-responsive custom table-striped text-center scrollable-table report-table">
                    <thead>
                        <tr>
                            <th style="min-width: 100px">
                                ID
                                <el-input
                                    v-model="filters.id"
                                    @keyup.native="filterLoggers(true)"/>
                            </th>
                            <th style="min-width: 100px">
                                Timestamp
                            </th>
                            <th style="min-width: 100px">
                                User
                                <el-input
                                    v-model="filters.creatorEmail"
                                    @keyup.native="filterLoggers(true)"/>
                            </th>
                            <th style="min-width: 100px">
                                Client IP
                                <el-input
                                    v-model="filters.clientIp"
                                    @keyup.native="filterLoggers(true)"/>
                            </th>
                            <th style="min-width: 100px">
                                Client Version
                                <el-input
                                    v-model="filters.clientVersion"
                                    @keyup.native="filterLoggers(true)"/>
                            </th>
                            <th style="min-width: 100px">
                                User Activity
                                <el-input
                                    v-model="filters.activityName"
                                    @keyup.native="filterLoggers(true)"/>
                            </th>
                            <th style="min-width: 100px">
                                Confirmation Number
                                <el-input
                                    v-model="filters.confirmationNumber"
                                    @keyup.native="filterLoggers(true)"/>
                            </th>
                            <!-- <th style="min-width: 100px">
                                Registrant ID
                                <el-input
                                    v-model="filters.registrantId"
                                    @keyup.native="filterLoggers(true)"/>
                            </th> -->
                            <th style="min-width: 100px">
                                Registrant First Name
                                <el-input
                                    v-model="filters.registrantFirstName"
                                    @keyup.native="filterLoggers(true)"/>
                            </th>
                            <th style="min-width: 100px">
                                Registrant Last Name
                                <el-input
                                    v-model="filters.registrantLastName"
                                    @keyup.native="filterLoggers(true)"/>
                            </th>
                            <th style="min-width: 100px">
                                Registrant Email
                                <el-input
                                    v-model="filters.registrantEmail"
                                    @keyup.native="filterLoggers(true)"/>
                            </th>
                            <th style="min-width: 100px">
                                JSON DATA
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="logger in loggers"
                            :key="`logger-${logger._id}`">
                                <td>{{ logger._id }}</td>
                                <td>{{ logger.createdAt | formatDate }}</td>
                                <td v-if="logger.activityName!='user/login'">{{ logger.creator ? logger.creator.email : '' }}</td>
                                <td v-else>{{ logger.data ? logger.data.email : '' }}</td>
                                <td>{{ logger.clientIp ? logger.clientIp : '' }}</td>
                                <td>{{ logger.clientVersion ? logger.clientVersion : '' }}</td>
                                <td>{{ logger.activityName }}</td>
                                <td>{{ logger.ConfirmationNumber }}</td>
                                <!-- <td>{{ logger.RegistrantID }}</td> -->
                                <td>{{ logger.RegistrantFirstName }}</td>
                                <td>{{ logger.RegistrantLastName }}</td>
                                <td>{{ logger.RegistrantEmail }}</td>
                                <td style="text-decoration: underline; cursor: pointer;" @click="toggleJsonDataShow(logger._id)">view json data</td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="total" class="row">
                    <div class="col-12 d-flex justify-content-end">
                        <el-pagination
                            background
                            layout="total, sizes, prev, pager, next, jumper"
                            @size-change="getRegistrations"
                            @current-change="getRegistrations"
                            :current-page.sync="page"
                            :total="total"
                            :page-size.sync="perPage"
                            :page-sizes="[50, 100, 200, 400, 500, 1000]">
                        </el-pagination>
                    </div>
                </div>
            </card>
        </div>

        <el-dialog 
            :close-on-click-modal="false"
            :visible.sync="showJsonData">

            <div v-if="loadingJsonData" class="d-flex justify-content-center">
                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            </div>

            <code v-else>
                <pre id="prettyprint" style="white-space: pre-wrap; word-wrap: break-word;">
                    {{ jsonData }}
                </pre>
            </code>
        
        </el-dialog>
    </div>
</template>
<style>
.report-table {
       width: initial;
    overflow: visible !important;
}
.report-row .card .card-body {
    height:80vh;
    overflow-x: auto;
    overflow-y: auto;
}
</style>
<script>
import http from '../http.js'
import moment from 'moment'
import download from 'downloadjs'
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
    data () {
        return {
            loading: true,
            loadingJsonData: true,
            allRegistrations: [],
            loggers: [],
            customFields: {},
            totals: {},
            registrationTypes: {},
            downloading: false,
            isParent: {},
            total: 0,
            perPage: 50,
            page: 1,
            jsonData:'',
            showJsonData: false,
            filters: {
                id: '',
                creatorEmail: '',
                clientIp: '',
                clientVersion: '',
                activityName: '',
                confirmationNumber: '',
                registrantId: '',
                registrantFirstName: '',
                registrantLastName: '',
                registrantEmail: '',
            },
            eventId: null,
            init: false
        }
    },
    computed: {
        ...mapState([
            'user',
        ]),
        getJsonData(){
            return this.jsonData
        }
    },
    mounted () {
        this.eventId = this.$route.params.eventId
        this.getLoggers()
        
    },
    methods: {
        async toggleJsonDataShow(id){
            this.showJsonData = true
            this.jsonData = null
            try {
                this.loadingJsonData = true
                const response = await http.get(`/api/get-one-log/${id}`)
                this.jsonData = response.data.log
            } catch (error) {
                console.log(error);
            }

            this.loadingJsonData = false
            

            let timer = setTimeout(() => {
                let p = document.querySelector("#prettyprint")
                p.textContent = p.textContent.replace(/^\s+/m, '');
                clearTimeout(timer)
                
            }, 100)

        },
        getLoggers: async function () {
            this.loading = true
            try {
                const response = await http.get('/api/loggers', {
                    params: {
                        select: 'activityName clientVersion ConfirmationNumber RegistrantFirstName RegistrantLastName RegistrantEmail clientIp createdAt creator.email data.email',
                        filters: {
                            populateParent: { select: 'confirmationNumber' },
                            populateType: { select: 'name groupCount' },
                            eventId: this.eventId,
                        }
                    }
                })
                this.total = response.data.total
                const loggers = response.data.loggers
                this.allLoggers = loggers
                this.filterLoggers()
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error getting data in loggers')
            }
            this.loading = false
        },
        filterLoggers: function (debounce = false) {
            const filter = () => {
                this.loggers = this.allLoggers.filter(logger => {
                    if (this.filters.id.length &&
                        logger._id.toUpperCase().indexOf(this.filters.id.toUpperCase()) === -1) {
                            return false
                    }
                    if (this.filters.creatorEmail !== null) {
                        if(logger.activityName!=="user/login"){
                            if(logger.creator && logger.creator.email.toUpperCase().indexOf(this.filters.creatorEmail.toUpperCase()) === -1)
                                return false;
                        }
                        if(logger.activityName=="user/login"){
                            if(logger.data && logger.data.email.toUpperCase().indexOf(this.filters.creatorEmail.toUpperCase()) === -1)
                                return false;
                        }
                    }
                    if (this.filters.clientIp.length &&
                        logger.clientIp.toUpperCase().indexOf(this.filters.clientIp.toUpperCase()) === -1) {
                            return false
                    }
                    if (this.filters.activityName &&
                        logger.activityName!== this.filters.activityName) {
                            return false
                    }
                    if (this.filters.confirmationNumber &&
                        logger.ConfirmationNumber !== this.filters.confirmationNumber) {
                            return false
                    }
                    if (this.filters.registrantId &&
                        logger.RegistrantId !== this.filters.registrantId) {
                            return false
                    }
                    if(this.filters.registrantFirstName && logger.RegistrantFirstName !== this.filters.registrantFirstName){  
                        return false;
                    }
                    if(this.filters.registrantLastName && logger.RegistrantLastName !== this.filters.registrantLastName){  
                        return false;
                    }
                    if(this.filters.registrantEmail && logger.RegistrantEmail !== this.filters.registrantEmail){
                        return false;
                    }
   
                    return true
                })
            }

            if (debounce) {
                let delay = _.debounce(() => {
                    filter()
                }, 300)
                delay()
            } else {
                filter()
            }
        },
        downloadUserLog: async function () {
            this.downloading = true
            try {
                const response = await http.post('/api/loggers/download', {
                    loggers: this.loggers,
                }, {
                    responseType: 'arraybuffer'
                })
                download(response.data, 'loggers.xlsx', '	application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error downloading list')
            }
            this.downloading = false
        },
    },
    filters: {
        formatDate: (value) => moment(value).format('YYYY-MM-DD HH:mm:ss'),
        deposit: (registration) => {
            let deposit = parseInt(registration.total) - parseInt(registration.paid)

            if (deposit < 0) {
                deposit = 0
            }
            
            return deposit
        },
        avlRegistrantCount: (value)=>{
            if(value.type.groupCount){
                let hasRegistrant = Object.values(value.type.groupCount).reduce((total,item)=>parseInt(total)+parseInt(item))
                return (hasRegistrant+1) - (value.registrants.length + 1 )
            }else{
                return '';
            }
        }
    }
}
</script>